import LogoIcon from './LogoIcon';
import LoginRightIcon from './LoginRightIcon';
import ToggleMenuIcon from './ToggleMenuIcon';
import NotificationIcon from './NotificationIcon';
import PlusIcon from './PlusIcon';
import ReceiptIcon from './ReceiptIcon';
import MenuBarIcon from './MenuBarIcon';
import PhoneIcon from './PhoneIcon';
import BackIcon from './BackIcon';
import ArrowIcon from 'src/components/svg/general/ArrowIcon';
import DoubleArrowIcon from 'src/components/svg/general/DoubleArrowIcon';
import RemoveIcon from 'src/components/svg/general/RemoveIcon';
import PlayIcon from 'src/components/svg/general/PlayIcon';
import PauseIcon from 'src/components/svg/general/PauseIcon';
import RecordingIcon from 'src/components/svg/general/RecordingIcon';
import PhotoCameraIcon from 'src/components/svg/general/PhotoCameraIcon';
import UploadIcon from 'src/components/svg/general/UploadIcon';
import DownloadIcon from 'src/components/svg/general/DownloadIcon';
import AtIcon from 'src/components/svg/general/AtIcon';
import NotificationApprovedIcon from 'src/components/svg/general/NotificationApprovedIcon';
import ClockIcon from './ClockIcon';
import ReplyIcon from './ReplyIcon';
import ForwardIcon from './ForwardIcon';
import PaymentSuccessIcon from './PaymentSuccessIcon';
import PaymentFailIcon from './PaymentFailIcon';
import CookieIcon from './CookieIcon';
import InfoIcon from './InfoIcon';
import CertificateIcon from './CertificateIcon';
import ArrowDownIcon from './ArrowDownIcon';
import ManagerIcon from './ManagerIcon';

import AppStore from './AppStore';
import GooglePlay from './GooglePlay';
import VerifyIcon from './VerifyIcon';
import AppleBlack from './AppleBlack';
import GoogleBlack from './GoogleBlack';

const index = {
  LOGO: LogoIcon,
  AppStore,
  GooglePlay,
  LOGO_RIGHT: LoginRightIcon,
  TOGGLE_MENU: ToggleMenuIcon,
  NOTIFICATION: NotificationIcon,
  'plus-icon': PlusIcon,
  'receipt-icon': ReceiptIcon,
  'menu-bar-icon': MenuBarIcon,
  'phone-icon': PhoneIcon,
  'back-icon': BackIcon,
  'arrow-icon': ArrowIcon,
  'double-arrow-icon': DoubleArrowIcon,
  'remove-icon': RemoveIcon,
  'play-icon': PlayIcon,
  'pause-icon': PauseIcon,
  'recording-icon': RecordingIcon,
  'photo-camera-icon': PhotoCameraIcon,
  UPLOAD: UploadIcon,
  'download-icon': DownloadIcon,
  'at-icon': AtIcon,
  'notification-approved-icon': NotificationApprovedIcon,
  CLOCK: ClockIcon,
  REPLY: ReplyIcon,
  FORWARD: ForwardIcon,
  PAYMENT_SUCCESS: PaymentSuccessIcon,
  PAYMENT_FAIL: PaymentFailIcon,
  GENERAL_COOKIE: CookieIcon,
  GENERAL_INFO: InfoIcon,
  CERTIFICATE_ICON: CertificateIcon,
  ARROW_DOWN: ArrowDownIcon,
  MANAGER: ManagerIcon,
  VERIFY: VerifyIcon,
  APPLE_BLACK: AppleBlack,
  GOOGLE_BLACK: GoogleBlack
};

export const GENERAL_ICONS = {
  INFO: 'GENERAL_INFO',
  COOKIE: 'GENERAL_COOKIE',
  CERTIFICATE: 'CERTIFICATE_ICON',
  NOTIFICATION: 'NOTIFICATION',
  TOGGLE_MENU: 'TOGGLE_MENU',
  LOGO: 'LOGO',
  LOGO_RIGHT: 'LOGO_RIGHT',
  FORWARD: 'FORWARD',
  REPLY: 'REPLY',
  PAYMENT_SUCCESS: 'PAYMENT_SUCCESS',
  PAYMENT_FAIL: 'PAYMENT_FAIL',
  CLOCK: 'CLOCK',
  UPLOAD: 'UPLOAD',
  ARROW_DOWN: 'ARROW_DOWN',
  MANAGER: 'MANAGER',
  VERIFY: 'VERIFY',
  APPLE_BLACK: 'APPLE_BLACK',
  GOOGLE_BLACK: 'GOOGLE_BLACK'
};

export default index;
